"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateInput = exports.useDateInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
require("./DateInput.css");
var InputContainer_1 = require("../../components/InputContainer");
var isType_1 = require("../../utils/isType");
var DatePicker_1 = require("../../components/DatePicker");
var locale_1 = require("../../utils/locale");
var date_fns_tz_1 = require("date-fns-tz");
var date_fns_1 = require("date-fns");
var Popover_1 = require("../../components/Popover");
var MDIcon_1 = require("../../components/MDIcon");
var Button_1 = require("../../components/Button");
var useDateInput = function (init) {
  var config = (0, react_1.useMemo)(function () {
    return parseDateInputInit(init);
  }, [init]);
  var _a = __read((0, react_1.useState)(config.startDate), 2),
    date = _a[0],
    setDate = _a[1];
  var _b = __read((0, react_1.useState)(""), 2),
    text = _b[0],
    setText = _b[1];
  var _c = __read((0, react_1.useState)(false), 2),
    visible = _c[0],
    setVisible = _c[1];
  var _d = __read((0, react_1.useState)(false), 2),
    valid = _d[0],
    setValid = _d[1];
  var onChange = function (inputDate) {
    var value = inputDate ? config.transform(inputDate) : config.transformClear();
    var shouldFireOnChange = !R.equals(value, date);
    setDate(value);
    if (shouldFireOnChange) {
      config.onChange(value);
    }
  };
  return {
    date: date,
    shown: visible,
    text: text,
    valid: valid,
    setValid: setValid,
    onChange: onChange,
    setShown: setVisible,
    setText: setText
  };
};
exports.useDateInput = useDateInput;
(0, MDIcon_1.preloadIcons)("calendar");
var DateInput = function (_a) {
  var _b, _c;
  var date = _a.date,
    visible = _a.shown,
    text = _a.text,
    valid = _a.valid,
    df = _a.dateFormat,
    timeZone = _a.timeZone,
    _d = _a.locale,
    lc = _d === void 0 ? "en" : _d,
    onChange = _a.onChange,
    setVisible = _a.setShown,
    setText = _a.setText,
    setValid = _a.setValid,
    showTimePicker = _a.showTimePicker,
    disabledDates = _a.disabledDates,
    disabledDay = _a.disabledDay,
    disabledTime = _a.disabledTime,
    timeInterval = _a.timeInterval,
    disabled = _a.disabled,
    popoverProps = _a.popoverProps,
    autoClose = _a.autoClose,
    startFocused = _a.startFocused,
    _e = _a.error,
    propError = _e === void 0 ? false : _e,
    _f = _a.clearable,
    clearable = _f === void 0 ? true : _f,
    _g = _a.showIcon,
    calendarIcon = _g === void 0 ? true : _g,
    _h = _a.focusOnClear,
    focusOnClear = _h === void 0 ? false : _h,
    _j = _a.onClick,
    onClick = _j === void 0 ? R.N : _j,
    _k = _a.onBlur,
    onBlur = _k === void 0 ? R.N : _k,
    _l = _a.onFocus,
    onFocus = _l === void 0 ? R.N : _l,
    _m = _a.onInput,
    onInput = _m === void 0 ? R.N : _m,
    _o = _a.onKeyDown,
    onKeyDown = _o === void 0 ? R.N : _o,
    _p = _a.onPaste,
    onPaste = _p === void 0 ? R.N : _p,
    datePickerProps = _a.datePickerProps,
    timePickerFormat = _a.timePickerFormat,
    timePickerEndOfDay = _a.timePickerEndOfDay,
    defaultTime = _a.defaultTime,
    restProps = __rest(_a, ["date", "shown", "text", "valid", "dateFormat", "timeZone", "locale", "onChange", "setShown", "setText", "setValid", "showTimePicker", "disabledDates", "disabledDay", "disabledTime", "timeInterval", "disabled", "popoverProps", "autoClose", "startFocused", "error", "clearable", "showIcon", "focusOnClear", "onClick", "onBlur", "onFocus", "onInput", "onKeyDown", "onPaste", "datePickerProps", "timePickerFormat", "timePickerEndOfDay", "defaultTime"]);
  var overrideClearable = disabled || restProps.readOnly;
  var showClearButton = clearable && text && !overrideClearable;
  var inputRef = (0, react_1.useRef)(null);
  var formatParseOptions = (0, react_1.useMemo)(function () {
    return {
      locale: (0, locale_1.getLocale)(lc !== null && lc !== void 0 ? lc : datePickerProps === null || datePickerProps === void 0 ? void 0 : datePickerProps.locale)
    };
  }, [lc, datePickerProps]);
  var dateFormat = (0, react_1.useMemo)(function () {
    return df !== null && df !== void 0 ? df : (0, locale_1.getDateFormatFromLocale)(lc);
  }, [df, lc]);
  var validateText = function (textValue) {
    var value = (0, date_fns_1.parse)(textValue, dateFormat, new Date(), formatParseOptions);
    setValid((0, isType_1.isDateValid)(value));
  };
  var error = (0, react_1.useMemo)(function () {
    if (propError) return true;
    if (R.isEmpty(text)) return false;
    return !valid;
  }, [text, propError, valid]);
  (0, react_1.useEffect)(function () {
    if (!date) {
      setValid(true);
      setText("");
    } else {
      var value = timeZone ? (0, date_fns_tz_1.formatInTimeZone)(date, timeZone, dateFormat, formatParseOptions) : (0, date_fns_1.format)(date, dateFormat, formatParseOptions);
      if (value !== text) {
        setText(value);
        validateText(value);
      }
    }
  }, [date]);
  (0, react_1.useLayoutEffect)(function () {
    var _a;
    if (startFocused) {
      (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, []);
  var trySetDate = function (text) {
    if (R.isNothing(text.trim())) {
      onChange(undefined);
      return;
    }
    var referenceDate = date !== null && date !== void 0 ? date : new Date();
    var dateValue = timeZone ? parseWithTimeZone(text, dateFormat, referenceDate, timeZone, formatParseOptions) : (0, date_fns_1.parse)(text, dateFormat, referenceDate, formatParseOptions);
    if ((0, isType_1.isDateValid)(dateValue)) {
      var shouldFireOnChange = !(0, date_fns_1.isEqual)(date !== null && date !== void 0 ? date : 0, dateValue);
      shouldFireOnChange && onChange(dateValue);
    }
  };
  var zonedDate = (0, react_1.useMemo)(function () {
    if (!date) return undefined;
    if (!timeZone) return date;
    return (0, date_fns_tz_1.utcToZonedTime)(date, timeZone);
  }, [date, timeZone]);
  var onDatePickerChange = function (newValue) {
    var _a;
    if (!timeZone) {
      onChange(newValue);
    } else {
      var v = (0, date_fns_tz_1.zonedTimeToUtc)(newValue, timeZone);
      onChange(v);
    }
    autoClose ? setTimeout(function () {
      return setVisible(false);
    }, 250) : (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  };
  var datePicker = (0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, __assign({
    date: zonedDate,
    onChange: onDatePickerChange,
    locale: lc,
    timePickerFormat: timePickerFormat,
    showTimePicker: showTimePicker,
    timeInterval: timeInterval,
    disabled: disabled || restProps.readOnly,
    disabledDates: disabledDates,
    disabledDay: disabledDay,
    disabledTime: disabledTime,
    style: {
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0
    },
    timePickerEndOfDay: timePickerEndOfDay,
    defaultTime: defaultTime
  }, datePickerProps));
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({}, popoverProps, {
      customColor: (_b = popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.customColor) !== null && _b !== void 0 ? _b : "#bfc0c2",
      contentStyle: {
        padding: 0
      },
      shown: visible,
      wrapperProps: __assign(__assign({}, popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.wrapperProps), {
        style: __assign({
          width: "250px"
        }, (_c = popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.wrapperProps) === null || _c === void 0 ? void 0 : _c.style)
      }),
      content: visible && datePicker,
      onClickOutside: function () {
        return setVisible(false);
      },
      maxWidth: 500,
      disabled: disabled || restProps.readOnly
    }, {
      children: (0, jsx_runtime_1.jsxs)(InputContainer_1.InputContainer, __assign({
        error: error,
        style: {
          paddingRight: showClearButton ? "6px" : undefined
        }
      }, {
        children: [calendarIcon && (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
          icon: "calendar"
        }), (0, jsx_runtime_1.jsx)("input", __assign({}, restProps, {
          ref: inputRef,
          disabled: disabled,
          value: text,
          onClick: function (e) {
            onClick(e);
            setVisible(true);
          },
          onInput: function (e) {
            onInput(e);
            setText(e.currentTarget.value);
            validateText(e.currentTarget.value);
            setVisible(false);
          },
          onBlur: function (e) {
            onBlur(e);
            trySetDate(text);
          },
          onPaste: function (e) {
            onPaste(e);
            e.preventDefault();
            trySetDate(e.clipboardData.getData("Text"));
            setVisible(false);
          },
          onKeyDown: function (e) {
            onKeyDown(e);
            if (e.key === "Enter") {
              e.preventDefault();
              trySetDate(text);
              setVisible(false);
            }
          },
          onFocus: function (e) {
            onFocus(e);
            setVisible(true);
          },
          onChange: R.N
        })), showClearButton && (0, jsx_runtime_1.jsx)(Button_1.IconButton, {
          icon: "close",
          size: 20,
          freeSize: true,
          style: {
            transform: "scale(0.8)",
            transformOrigin: "right"
          },
          onClick: function () {
            var _a;
            onChange(undefined);
            setValid(true);
            setText("");
            focusOnClear ? (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus() : setVisible(false);
          }
        })]
      }))
    }))
  });
};
exports.DateInput = DateInput;
var parseWithTimeZone = function (dateStr, formatStr, referenceDate, timeZone, formatParseOptions) {
  var zonedDate = (0, date_fns_tz_1.utcToZonedTime)(referenceDate, timeZone);
  var parsedDate = (0, date_fns_1.parse)(dateStr, formatStr, zonedDate, formatParseOptions);
  return (0, date_fns_tz_1.zonedTimeToUtc)(parsedDate, timeZone);
};
var parseDateInputInit = function (initializer) {
  var _a, _b, _c;
  var startDate;
  var onChange = R.N;
  var transform = R.identity;
  var transformClear = R.always(undefined);
  if ((0, isType_1.isDateValid)(initializer)) {
    startDate = initializer;
  } else if ((0, isType_1.isPlainObject)(initializer)) {
    startDate = (0, isType_1.isDateValid)(initializer.startDate) ? initializer.startDate : undefined;
    onChange = (_a = initializer.onChange) !== null && _a !== void 0 ? _a : R.N;
    transform = (_b = initializer.transform) !== null && _b !== void 0 ? _b : R.identity;
    transformClear = (_c = initializer.transformClear) !== null && _c !== void 0 ? _c : R.always(undefined);
  }
  return {
    startDate: startDate,
    onChange: onChange,
    transform: transform,
    transformClear: transformClear
  };
};